import React from 'react';

import {
    ButtonComponent as OmegaButtonComponent,
    ButtonSize as OmegaButtonSize,
    ButtonVariant as OmegaButtonVariant
} from '@nw/design-system/omega';

import { ButtonProps } from './types';

export const OmegaButton: React.FC<ButtonProps> = (props) => {
    const {
        variant,
        size,
        isDisabled,
        isLoading,
        onClick,
        className,
        children,
        id,
        type,
        shouldShrinkButtonWhileLoading,
        childrenClassName,
        ...otherProps
    } = props;

    // Map variant from Omega format to Omega format (no change needed, but ensure type safety)
    const omegaVariant = variant as OmegaButtonVariant;

    // Map size from Omega format to Omega format (no change needed, but ensure type safety)
    const omegaSize = size as OmegaButtonSize;

    return (
        <OmegaButtonComponent
            id={id}
            isDisabled={isDisabled}
            isLoading={isLoading}
            variant={omegaVariant}
            size={omegaSize}
            onClick={onClick}
            className={className}
            type={type}
            shouldShrinkButtonWhileLoading={shouldShrinkButtonWhileLoading}
            childrenClassName={childrenClassName}
            {...otherProps}
        >
            {children}
        </OmegaButtonComponent>
    );
};

